import Vue from 'vue';
import Axios from 'axios';
import VueTheMask from 'vue-the-mask';
import VueMoney from 'v-money';
import VueSelect from 'vue-select';
import BootstrapVue, {
  BTooltip,
  ModalPlugin,
  ToastPlugin,
} from 'bootstrap-vue';
import VueLazyLoad from 'vue-lazyload';
import VueCarousel from 'vue-carousel';
import VueAnalytics from 'vue-analytics';
import CKEditor from '@ckeditor/ckeditor5-vue';
import VueClipboard from 'vue-clipboard2';
import GAuth from 'vue-google-oauth2';
import VueCookies from 'vue-cookies';

import Modals from './components/Modals.vue';
import BaseView from './components/View/BaseView.vue'
import BaseViewTable from './components/View/BaseViewTable.vue'
import SelectItems from './components/Inputs/SelectItems.vue';

import store from './store/store';
import router from './routes/router';
import Utils from './utils/index';
import App from './App.vue';

import './registerServiceWorker';
import 'vue-select/dist/vue-select.css';
import VueObserveVisibility from 'vue-observe-visibility'

router.beforeEach((to, from, next) => {
  if (to.meta.userType) {
    if (
      store.state.dadosUsuario !== null &&
      to.matched.some(
        (route) =>
          route.meta.userType === store.state.dadosUsuario.tipo_usuario_id
      )
    ) {
      next();
    } else next({ name: 'sair' });
  } else next();
});

function setConfigs(config) {
  store.dispatch('config/changeApiUrl', config.ApiUrl);
  store.dispatch('config/changeCaptchaKey', config.ApiUrl);
  store.dispatch('config/changeGoogleClientId', config.Google.ClientId);
  store.dispatch('config/changeFacebookClientId', config.Facebook.ClientId);
}

Axios.get('/static/config.json')
  .then((response) => {
    setConfigs(response.data);
  })
  .catch((ex) => {
    console.log(
      `Erro ao carregar o arquivo de configuração config.json: ${ex}`
    );
  });

Vue.component('Modals', Modals);
Vue.component('v-select', VueSelect);
Vue.component('BTooltip', BTooltip);
Vue.component('base-view', BaseView);
Vue.component('base-view-table', BaseViewTable);
Vue.component('select-items', SelectItems);

const gauthOption = {
  clientId:
    '30765178059-q5lv8ldn53jli0i27tenpsns3bbil0od.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
};

Vue.use(VueCookies);
Vue.use(GAuth, gauthOption);
Vue.use(VueAnalytics, {
  id: 'UA-147114392-1',
  router,
  autoTracking: {
    screenview: true,
    pageviewOnLoad: true,
  },
});
Vue.use(CKEditor);
Vue.use(VueClipboard);
Vue.use(VueTheMask);
Vue.use(VueMoney, {
  decimal: ',',
  thousands: '.',
  prefix: 'R$ ',
  suffix: '',
  precision: 2,
  masked: false,
});
Vue.use(VueCarousel);
Vue.use(VueLazyLoad);
Vue.use(BootstrapVue);
Vue.use(ModalPlugin);
Vue.use(ToastPlugin);
Vue.use(VueObserveVisibility);

// Global functions and variables
Vue.config.productionTip = false;
Vue.prototype.$validate = Utils.validations;
// Vue.prototype.$notificationModal = Utils.notificationModal;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
